import { defineCustomElement as defineBrButton } from "@govbr-ds/webcomponents/dist/components/br-button";
import { defineCustomElement as defineBrCard } from "@govbr-ds/webcomponents/dist/components/br-card";
import { defineCustomElement as defineBrCollapse } from "@govbr-ds/webcomponents/dist/components/br-collapse";
import { defineCustomElement as defineBrInput } from "@govbr-ds/webcomponents/dist/components/br-input";
import { defineCustomElement as defineBrLink } from "@govbr-ds/webcomponents/dist/components/br-link";
import { defineCustomElement as defineBrLoading } from "@govbr-ds/webcomponents/dist/components/br-loading";
import { defineCustomElement as defineBrMessage } from "@govbr-ds/webcomponents/dist/components/br-message";
import { defineCustomElement as defineBrSelect } from "@govbr-ds/webcomponents/dist/components/br-select";
import { defineCustomElement as defineBrTextarea } from "@govbr-ds/webcomponents/dist/components/br-textarea";

[
  defineBrButton,
  defineBrCard,
  defineBrCollapse,
  defineBrInput,
  defineBrLink,
  defineBrLoading,
  defineBrMessage,
  defineBrSelect,
  defineBrTextarea
].forEach((defineComponent) => defineComponent());
